import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FundAction } from "../../../actions";
import ToolsDescription from "../components/description";
import ToolsSearch from "../components/search";
import Table from "../../../components/table";
import { Sortable } from "../../../components/sort";
import { Confirm } from "../../../components/confirm";
import { EmptyState } from "../../../components/emptyState";
import { BoxLoading } from "../../../components/loading";
import { ToolsTop, ToolsBody, TruncateText } from "../style";
import { ToPersian } from "../../../lib/changeNumber";
import ToEnglish from "../../../lib/persianNumberToEnglish";

class Wallet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: null,
      sortField: "name",
      sortType: "asc",
      showModal: false
    };

    this.sortHandleClick = this.sortHandleClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.setDefault = this.setDefault.bind(this);
    this.deleteHandleClick = this.deleteHandleClick.bind(this);
    this.rowRender = this.rowRender.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    !this.props.list.length && this.props.getAll();
  }

  async sortHandleClick(sortField) {
    const { sortType } = this.state;

    this.setState({
      sortField,
      sortType: sortType === "desc" ? "asc" : "desc"
    });
  }

  onEdit(id) {
    this.props.history.push(`/wallet/${id}/edit`);
  }

  rowRender(item) {
    return (
      <Table.Row key={item.id}>
        <Table.Cell onClick={() => this.onEdit(item.id)} className="name">
          {item.name}
        </Table.Cell>
        <Table.Cell
          onClick={() => this.onEdit(item.id)}
          className="description"
        >
          <TruncateText width="40vw">{item.description}</TruncateText>
        </Table.Cell>
        <Table.Cell className="row-controls-button">
          <div className="hidden-td">
            <i
              onClick={() => this.setDefault(item)}
              className={
                `no-select icon mapsa-tick green` +
                (item.is_default ? " active" : "")
              }
              title="پیش‌فرض"
            />
            <i
              onClick={() => this.deleteHandleClick(item)}
              className="no-select icon mapsa-trash red"
              title="حذف"
            />
          </div>
        </Table.Cell>
      </Table.Row>
    );
  }

  onSearch(query) {
    this.setState({
      query: query
    });
  }

  setDefault(item) {
    this.props.setDefault(item);
  }

  deleteHandleClick(item) {
    this.setState({ showConfirm: true, deleteItemId: item.id });
  }

  render() {
    const description =
      "​​صندوق ها مانند کیف پول یا جیب شما هستند و شما می توانید بابت وجوهی که از حساب بانکی خاصی پرداخت نمی کنید، یک یا چند صندوق ایجاد کنید.";
    const { loading, list } = this.props;
    const {
      showConfirm,
      deleteItemId,
      query,
      sortField,
      sortType
    } = this.state;

    const filteredList = list
      .filter(
        item =>
          !query ||
          item.name.indexOf(ToEnglish(query)) !== -1 ||
          item.name.indexOf(ToPersian(query)) !== -1
      )
      .sort((prev, next) =>
        sortType === "asc"
          ? prev[sortField] < next[sortField]
            ? -1
            : 1
          : prev[sortField] > next[sortField]
          ? -1
          : 1
      );

    return (
      <React.Fragment>
        {!loading ? (
          list.length !== 0 ? (
            <React.Fragment>
              <ToolsTop>
                <ToolsDescription
                  icon="icon mapsa-wallet"
                  color="#7e57c2"
                  title="صندوق"
                  description={description}
                />
                <ToolsSearch onSearch={this.onSearch} query={query} />
              </ToolsTop>
              <ToolsBody>
                {filteredList.length > 0 ? (
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="name">
                          <Sortable
                            sort={{ sortField, sortType, value: "name" }}
                            currency={false}
                            label={"نام صندوق"}
                            sortHandleClick={this.sortHandleClick}
                          />
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          className="description"
                          style={{ maxWidth: "50%" }}
                        >
                          توضیحات
                        </Table.HeaderCell>
                        <Table.HeaderCell className="row-controls-button"></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{filteredList.map(this.rowRender)}</Table.Body>
                  </Table>
                ) : (
                  <EmptyState tabIcon={"icon mapsa-search"}>
                    متاسفانه موردی یافت نشد.
                  </EmptyState>
                )}
              </ToolsBody>
              <Confirm
                show={showConfirm}
                content={{
                  type: "danger",
                  icon: "icon mapsa-notification",
                  message: "آیا از پاک کردن این صندوق اطمینان دارید؟",
                  acceptButtonText: "حذف",
                  rejectButtonText: "انصراف"
                }}
                acceptHandler={() => {
                  this.props.remove(deleteItemId);
                  this.setState({ showConfirm: false });
                }}
                rejectHandler={() => this.setState({ showConfirm: false })}
                close={() => this.setState({ showConfirm: false })}
              />
            </React.Fragment>
          ) : (
            <EmptyState tabIcon={"icon mapsa-outline-layers"}>
              {description}
            </EmptyState>
          )
        ) : (
          <BoxLoading />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.Fund.data,
    loading: store.Fund.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAll: () => {
      dispatch(FundAction.getAllRequest());
    },
    setDefault: id => {
      dispatch(FundAction.setDefaultRequest(id));
    },
    remove: id => {
      dispatch(FundAction.removeRequest(id));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Wallet)
);

export const Sidebar = {
  addButton: { title: "ایجاد صندوق" },
  menu: [{ title: "صندوق‌ها", icon: "mapsa-wallet", link: "/wallet" }]
};
